import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Button from 'components/common/Button/Button'
import { A } from 'components/common/Link/Link'
import { H2 } from 'components/common/Text/Text'
import Columns from 'components/common/Columns/Columns'
import UpdatingBlock from 'components/common/UpdatingBlock'
import { WarrantyBadgeTitle } from 'components/common/WarrantyBadge'
import TireRating from '../TireRating'

export const Block = styled.div`
  display: table;
  width: 100%;
`

export const Cell = styled.div`
  display: block;
  padding: 25px 20px 0;
  ${Media.desktop`
    max-width: 250px;
    display: table-cell;
    vertical-align: top;
  `}
  ${Media.tabletSmall`
    padding: 25px 10px 0 0;
  `}
  ${Media.mobile`
    padding: 25px 10px 0;
  `}
`

export const CellLeft = styled(Cell)`
  display: table-cell;
  padding: 0 10px 20px 0;
  text-align: center;
  vertical-align: top;
  ${Media.desktop`
    width: 180px;
  `}
  ${Media.tabletSmall`
    padding-right: 0;
  `}
`

export const CellRight = styled(Cell)`
  padding: 0;
  display: table-cell;
  vertical-align: top;
`

export const Right = styled(Cell)`
  padding: 15px 20px 20px;
  background: ${Theme.colors.off_white};
  ${Media.desktop`
    border-left: 1px solid ${Theme.colors.light_grey};
    border-top: none;
    width: 253px;
    display: table-cell;
    vertical-align: top;
  `}
  ${Media.mobile`
    border-top: 1px solid ${Theme.colors.light_grey};
  `}
`

export const RightUpdatingBlock = Right.withComponent(UpdatingBlock)

export const Tire = styled.img`
  max-width: 100%;
  min-width: 42px;
  margin: 0 auto;
  position: relative;
  ${Media.tabletSmall`
    width: 150px;
  `}
`

export const Logo = styled.img`
  max-width: 200px;
  cursor: pointer;
`

export const TireLineName = styled(H2)`
  display: inline-block;
  min-height: 38px;
  font-size: 18px;
  line-height: 24px;

  &:hover {
    text-decoration: underline;
  }
`

export const PriceLink = styled(A)`
  display: inline-block;
  font-size: 12px;
  line-height: 17px;
  ${Mixin.responsive('margin', '20px 0 0', '17px 0 0')}
`

export const CustomButton = styled(Button)`
  ${Mixin.responsive('padding', '7px 30px 8px', '11px 12px 9px')}
`

export const ButtonColumns = styled(Columns)`
  [data-column]:first-child {
    padding-right: 5px;
  }

  [data-column]:last-child {
    padding-left: 5px;
  }
`
export const ExpanderButtonContent = styled.div`
  padding: 20px 0;
`

export const CompareBtnWrapper = styled.div`
  margin-top: 20px;

  & button {
    padding: 7px 25px 8px;
  }
`

export const CompatibilityWrapper = styled.div`
  ${Mixin.responsive('max-width', '200px', '100%')}
  ${Mixin.responsive('margin-top', '0', '10px')}
`
export const SizeWrapper = styled.div`
  display: block;
`

export const Rating = styled(TireRating)`
  ${Mixin.responsive('margin-top', '10px', '0')}
`

export const BadgeWrapper = styled.div`
  margin-right: 10px;
`
export const ProductHeader = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  ${Media.mobile`
    flex-direction: column;
    align-items: flex-start;
  `}
  ${Media.tablet`
    align-items: flex-start;
    flex-direction: column;
  `}
`

export const LeftCell = styled.div`
  display: flex;
`

export const TireImageWrapper = styled.div`
  ${Media.mobile`
    width: 43%;
  `}
`

export const RightCell = styled.div`
  display: flex;
  flex-direction: column;
`

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  ${Media.mobile`
    width: 57%;
    padding: 0;
  `}
`
export const ProductDetailsBottom = styled.div`
  border-right: 1px solid ${Theme.colors.light_grey};
  padding-right: 25px;
  min-height: 100px;
  ${Media.mobile`
    padding: 0;
    border: 0;
    min-height: auto;
  `}
  ${Media.tablet`
    padding: 0;
    border: 0;
    min-height: auto;
  `}
`
export const WarrantyWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 60px;
  padding-left: 25px;
  ${Media.mobile`
    padding: 15px 10px 0 10px;
    border: 0;
    margin: 0;
  `}
  ${Media.tablet`
    margin-top: 10px;
  `}
`

export const WarrantyBadgeTitleWrapper = styled(WarrantyBadgeTitle)`
  margin-top: 0;
`

export const AvailabilityWrapper = styled.div`
  border-bottom: 1px solid ${Theme.colors.light_grey};
  padding: 8px 20px;
  background-color: ${Theme.colors.white};
  margin: -15px -20px 15px;
`
